module.exports = __webpack_public_path__ + "static/media/sb.9ebf90e7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sb.svg
// module id = 2202
// module chunks = 0